import { countryCodes } from 'mdc-constants';

export const getCountryIso = (countryName: string) => countryCodes.find(
  (item) => item.value === countryName,
)?.code || '';

export const getCountryName = (isoCode: string) => countryCodes.find(
  (item) => item.code === isoCode,
)?.value || '';
